import React, { useState, useCallback } from "react";
import { useDebounce } from "react-use";
import { TextInput } from "../../../components/input";
import { Icon } from "../../../components/icon";
var SearchInput = function (_a) {
    var defaultValue = _a.defaultValue, setSearchTerm = _a.setSearchTerm, setSearchView = _a.setSearchView;
    var _b = useState(defaultValue), value = _b[0], setValue = _b[1];
    useDebounce(function () {
        setSearchTerm(value);
        if (value.length < 3)
            return;
        setSearchView();
    }, 300, [value]);
    var onChange = useCallback(function (e) { return setValue(e.target.value); }, []);
    return (React.createElement(TextInput, { value: value, onChange: onChange, placeholder: "Search Netdata\u2019s docs & community", autoFocus: true, metaShrinked: true, iconLeft: React.createElement(Icon, { name: "search_s", size: "small", color: value ? "text" : "border" }) }));
};
export default SearchInput;
